import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZArray, ZMath, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XIconButton, XScroll, XText } from "IZOX/_X";
import { Markdown, QForm } from "IZOX/BLOCKS/Libs";
import { QFCheckBox, QFDate, QFDropUpload, QFDropdown, QFRadio, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import Options from "shared/Options";
import Styles from "__SYSDefault/Styles";
import _ from "lodash";
import { MdClose } from "react-icons/md";
import QUICKUI from "shared/QUICKUI";
import VarList from "shared/VarList";
import agreementEN from "../_agreementEN";
import agreementTC from "../_agreementTC";
import Stepper from "shared/Stepper";
import paymentinstEN from "../_paymentinstEN";
import paymentinstTC from "../_paymentinstTC";
import FPSQR from "shared/FPSQR";

/**
 * @augments {Component<Props, State>}
 */
class NewPolicyM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      curStep: 0,
      CIFormValue: {
        _newClient: false,
      },
      insuranceFormValue: {
        questions: {
          medical: false,
          reject: false
        }
      },
      recFormValue: {},
      insured: [
        {
          _newMaid: false
        }
      ],
      oldClients: [],
      oldMaids: [],
      totalAmount: 0,
      minTotalAmount: 0,
      packagesAvailable: []
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.OnLoad();
      this.GetNationalityList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewPolicyM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  OnLoad = async () => {
    await this.GetClients();
    await this.GetMaids();
    await this.GetPolicyPackage();
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  GetClients = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetClients");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        oldClients: payload
      });
    }

  }

  GetMaids = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetMaids");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        oldMaids: payload
      });
    }
  }

  GetPolicyPackage = async () => {
    let res = await ReqX.SendBE("/Web/Agent/GetPolicyPackage");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        packagesAvailable: payload
      });
    }
  }

  _onSubmit = async () => {
    let {CIFormValue, insured, insuranceFormValue, recFormValue} = this.state;
    let ciForSubmit = _.omit(CIFormValue ?? {}, ["_employmentAddrPreset"]);
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/Agent/SubmitNewPolicy", {
        CIFormValue: ciForSubmit, insured, insuranceFormValue, recFormValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
  }

  _createNewPolicy = () => {
    this.setState({
      curStep: 0,
      CIFormValue: {
        _newClient: false,
      },
      insuranceFormValue: {
        questions: {
          medical: false,
          reject: false
        }
      },
      recFormValue: {},
      insured: [
        {
          _newMaid: false
        }
      ],
      totalAmount: 0,
      minTotalAmount: 0
    }, () => {
      this.OnLoad();
    });
  }

  _onStepChange = (step) => {
    this.setState({
      curStep: step
    });
  }

  _onCIChange = (formValue, name, value) => {
    if(name === "_newClient"){
      if(value){
        formValue = {
          _newClient: true
        };
      }
    }
    if(name === "_sameWorkingAddress" && value){
      formValue = {...formValue};
      delete formValue._employmentAddrPreset;
    }

    this.setState({
      CIFormValue: formValue
    });
  }

  _applyEmploymentAddressFromSaved = (val) => {
    if(val === undefined || val === null || val === ""){
      return;
    }
    let {CIFormValue} = this.state;
    let idx = Number(val);
    if(!Number.isFinite(idx) || idx < 0){
      return;
    }
    let rows = CIFormValue?.meta?.additionalAddress ?? [];
    let addr = rows[idx];
    if(!addr){
      return;
    }
    let next = {
      ...CIFormValue,
      workingAddress: {
        EN: addr.EN ?? "",
        TC: addr.TC ?? ""
      }
    };
    delete next._employmentAddrPreset;
    this._onCIChange(next);
  }

  _onInsuredChange = (idx, formValue, name, value) => {
    let {insured} = this.state;
    if(name === "_newMaid"){
      if(value){
        formValue = {
          _newMaid: true
        };
      }
    }

    insured[idx] = formValue;
    this.setState({
      insured: insured
    });
  }

  _onInsuranceChange = (formValue) => {
    let {insured, packagesAvailable} = this.state;
    let containsMale = !_.every(insured, o => o.m_gender === "F");
    let {_package} = formValue ?? {};
    let totalAmount = 0;
    let minTotalAmount = 0;

    if(_package){
      let [packageID, year] = _package?.split("_");
      let _sel = _.find(packagesAvailable, o => o._id === packageID);
      let _year = _.find(_sel?.duration, o => o.year === Number(year));
      totalAmount = (insured?.length ?? 0) * _year?.price;
      minTotalAmount = (insured?.length ?? 0) * _year?.minPrice;

      _.map(insured, (o, i) => {
        let _startAt = Accessor.Get(formValue, `proposeStartAt.${i}`);
        if(_startAt){
          let _endAt = ZTime.Moment(_startAt).add(year, "year").toISOString();
          Accessor.Set(formValue, `proposeEndAt.${i}`, _endAt);
        }
      });
    }

    if(containsMale){
      _.map(insured, (o, i) => {
        let _startAt = Accessor.Get(formValue, `proposeStartAt.${i}`);
        let _maleDuration = Accessor.Get(formValue, "_maleDuration");
        if(_startAt && _maleDuration){
          let _endAt = ZTime.Moment(_startAt).add(Number(_maleDuration), "year").toISOString();
          Accessor.Set(formValue, `proposeEndAt.${i}`, _endAt);
        }
      });
    }

    this.setState({
      insuranceFormValue: formValue,
      totalAmount: totalAmount,
      minTotalAmount: minTotalAmount
    });
  }

  _onRecChange = (formValue) => {
    this.setState({
      recFormValue: formValue
    });
  }

  _addInsured = () => {
    let {insured} = this.state;
    insured.push({});
    this.setState({
      insured: insured
    });
  }

  _removeInsured = (idx) => {
    let {insured} = this.state;
    insured = ZArray.DeleteIdx(insured, idx);
    this.setState({
      insured: insured
    });
  }

  _addRow = (name) => {
    let {CIFormValue} = this.state;
    let target = Accessor.Get(CIFormValue, name) ?? [];
    target = [...target, ""];
    Accessor.Set(CIFormValue, name, target);
    this._onCIChange(CIFormValue);
  }

  _removeRow = (name, idx) => {
    let {CIFormValue} = this.state;
    let target = Accessor.Get(CIFormValue, name) ?? [];
    target = ZArray.DeleteIdx(target, idx);
    Accessor.Set(CIFormValue, name, target);
    this._onCIChange(CIFormValue);
  }

  _selectOldClient = (clientID) => {
    let {oldClients} = this.state;
    let clientDoc = _.find(oldClients, o => o._id === clientID);
    if(!clientDoc) {
      GFunc.Alert({
        EN: "Client not found.",
        TC: "找不到客戶。"
      }, "error");
      return;
    }
    this.setState({
      CIFormValue: {
        _newClient: false,
        existingClient: clientID,
        meta: {
          fullName: clientDoc.meta.fullName,
          gender: clientDoc.meta.gender,
          HKID: clientDoc.meta.HKID,
          mailingAddress: clientDoc.meta.mailingAddress,
          primaryAddress: clientDoc.meta.primaryAddress,
          additionalAddress: clientDoc.meta.additionalAddress
        },
        zip: clientDoc.zip,
        telNo: clientDoc.telNo,
        email: clientDoc.email,
        _sameWorkingAddress: true
      }
    });
  }

  _selectOldMaid = (idx, maidID) => {
    let {insured, oldMaids} = this.state;
    let maidDoc = _.find(oldMaids, o => o._id === maidID);
    insured[idx] = {
      _newMaid: false,
      existingMaid: maidID,
      m_fullName: maidDoc?.fullName,
      m_dateOfBirth: maidDoc?.dateOfBirth,
      m_gender: maidDoc?.gender,
      m_passport: maidDoc?.passport,
      m_nationality: maidDoc?.nationality
    };
    this.setState({
      insured: insured
    });
  }

  _close = () => {
    let {refreshFunc} = this.props;
    refreshFunc?.();
    GFunc.CloseBackdrop();
  }

  _backCI = () => {
    this.setState({
      curStep: 0
    }, () => {
      this.OnLoad();
    });
  }

  _toInsured = () => {
    this.setState({
      curStep: 1
    });
  }

  _toInsurance = () => {
    this.setState({
      curStep: 2
    });
  }

  _toSign = () => {
    this.setState({
      curStep: 3
    });
  }

  _toConfirmation = () => {
    this.setState({
      curStep: 4
    });
  }

  _toSuccess = () => {
    this.setState({
      curStep: 5
    });
  }

  _validateCI = () => {
    let {CIFormValue} = this.state;
    let valid = ZValidate.CheckAllFields(CIFormValue, 
      ["meta.fullName.EN", 
        "meta.HKID", "telNo", "email", 
        "meta.primaryAddress.EN"], "required");
    if(!valid) return false;
    if(CIFormValue?._newClient){
      valid = ZValidate.CheckAllFields(CIFormValue,
        ["meta.HKID"], ["isHKID"]);
      if(!valid) return false;
    }
    if(!CIFormValue._sameWorkingAddress){
      valid = ZValidate.CheckAllFields(CIFormValue, ["workingAddress.EN"], "required");
    }
    if(!valid) return false;
    return true;
  }

  _validateInsured = () => {
    let {insured} = this.state;
    let valid = _.every(insured, o => ZValidate.CheckAllFields(o, 
      ["m_fullName", "m_dateOfBirth", "m_gender", "m_passport", "m_nationality"],
      ["required"]));
    return valid;
  }

  _validateInsurance = () => {
    let {insuranceFormValue, minTotalAmount, insured} = this.state;

    let containsMale = !_.every(insured, o => o.m_gender === "F");

    let valid = ZValidate.CheckAllFields(insuranceFormValue, 
      ["proposeStartAt", "proposeEndAt", "questions.medical", "questions.reject"], 
      ["required"]);
    if(!valid) return false;

    if(containsMale){
      valid = ZValidate.CheckAllFields(insuranceFormValue, 
        ["_maleDuration"], 
        ["required"]);
      if(!valid) return false;
    } else {
      valid = ZValidate.CheckAllFields(insuranceFormValue, 
        ["_package"], 
        ["required"]);
      if(!valid) return false;
    }

    valid = ZValidate.CheckAllFields(insuranceFormValue, 
      ["responsibleAgentEmail"], "email");
    if(!valid) return false;

    if(insuranceFormValue?.questions?.medical === true){
      valid = ZValidate.CheckAllFields(insuranceFormValue, 
        ["questions.medicalinfo"], 
        ["required"]);
      if(!valid) return false;
    }

    if(insuranceFormValue?.questions?.reject === true){
      valid = ZValidate.CheckAllFields(insuranceFormValue, 
        ["questions.history"], 
        ["required"]);
      if(!valid) return false;
    }

    let receiptPrice = Accessor.Get(insuranceFormValue, "receiptPrice");
    let isOverMin = false;
    if(!containsMale && receiptPrice){
      isOverMin = receiptPrice < minTotalAmount;
    }
    if(isOverMin) return false;

    let salary = Accessor.Get(insuranceFormValue, "questions.salary");
    if(salary && salary <= 0) return false;

    return valid;
  }

  _validateReceipt = () => {
    let {recFormValue} = this.state;
    let valid = ZValidate.CheckAllFields(recFormValue, 
      ["agreement"],
      ["boolTrue"]);
    
    if(!valid) return false;
    valid = ZValidate.CheckUploads(recFormValue, ["documents", "receipts"]);
    if(!valid) return false;
    
    return valid;
  }

  renderTitleBar(){
    return (
      <HStack p={16} shadow flexShrink={0}>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Add new policy",
            TC: "增加保單"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderStepper(){
    let {curStep} = this.state;
    return (
      <VStack fullWidth flexShrink={0}>
        <Stepper
          curStep={curStep}
          barWidth={40}
          steps={[
            {EN: "Customer's Information", TC: "客戶資訊"},
            {EN: "Insured's information", TC: "受保人資訊"},
            {EN: "Insurance", TC: "保險"},
            {EN: "Signature & receipt", TC: "簽名及收據"}
          ]}/>
      </VStack>
    );
  }

  renderPreviewInurance(){
    return this.renderInsurance(true);
  }

  renderPreviewRec(){
    return this.renderSuppDoc(true);
  }

  renderPreviewCI(){
    let {CIFormValue} = this.state;
    let {meta, telNo, email} = CIFormValue ?? {};
    return (
      <VStack fullWidth pB={4} pH={16}>
        <VStack bW={2} bColor={ColorX.CSS("Leaf")} fullWidth>
          <HStack bgColor={ColorX.CSS("Leaf")} HAlign="[" pH={16} pV={8}>
            <XText color={ColorX.CSS("pureWhite")} bold>
              {LocaleX.Parse({
                EN: "Client's Information",
                TC: "客戶資料"
              })}
            </XText>  
          </HStack>
        </VStack>
        <VStack fullWidth HAlign="[" pV={10} spacing={10} bColor={ColorX.CSS("Leaf")} bW={2}>
          <HStack pH={10}>
            {QUICKUI.TextPreview(
              {EN: "Full name", TC: "姓名"},
              meta?.fullName?.EN ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
              meta?.fullName?.TC ?? "NULL"
            )}
          </HStack>
          <HStack pH={10}>
            {QUICKUI.TextPreview(
              {EN: "Email", TC: "電郵"},
              email ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Gender", TC: "性別"},
              Options.GetOption("Gender", meta?.gender)?.cap ?? "NULL"
            )}
          </HStack>
          <HStack pH={10}>
            {QUICKUI.TextPreview(
              {EN: "HKID number", TC: "香港身份證號碼"},
              meta?.HKID ?? "NULL"
            )}
            {QUICKUI.TextPreview(
              {EN: "Mobile phone", TC: "手機號碼"},
              telNo ? `+852 ${telNo}` : "NULL"
            )}
          </HStack>
          <HStack pH={10}>
            {QUICKUI.TextPreview(
              {EN: "Address (English)", TC: "地址 (英文)"},
              meta?.primaryAddress?.EN ?? "NULL",
              "100%"
            )}
            {QUICKUI.TextPreview(
              {EN: "Address (Chinese)", TC: "地址 (中文)"},
              meta?.primaryAddress?.TC ?? "NULL",
              "100%"
            )}
          </HStack>
          {_.map(meta?.additionalAddress, (o, i) => {
            return (
              <HStack pH={10} key={i}>
                {QUICKUI.TextPreview(
                  {
                    EN: `Additional Address #${i+1}`,
                    TC: `附加地址 #${i+1}`
                  },
                  `${meta?.additionalAddress?.[i]?.EN}` ?? "NULL",
                  "100%"
                )}
                {QUICKUI.TextPreview(
                  {
                    EN: "(Chinese)",
                    TC: "(中文)"
                  },
                  `${meta?.additionalAddress?.[i]?.TC}` ?? "NULL",
                  "100%"
                )}
              </HStack>
            );
          })}
        </VStack>
      </VStack>
    );
  }

  renderPreviewInsured(o, i){
    let {nationalities} = this.state;
    let {m_fullName, m_dateOfBirth, m_gender, m_passport, m_nationality} = o;
    let _gender = Options.GetOption("Gender", m_gender);
    let _nationality = VarList.GetOption(nationalities, m_nationality);
    return (
      <VStack fullWidth pB={4} pH={16} key={i}>
        <VStack bW={2} bColor={ColorX.CSS("Leaf")} fullWidth>
          <HStack bgColor={ColorX.CSS("Leaf")} HAlign="[" pH={16} pV={8}>
            <XText color={ColorX.CSS("pureWhite")} bold>
              {LocaleX.Parse({
                EN: `Helper #${i + 1}`,
                TC: `僱傭 #${i + 1}`,
              })}
            </XText>  
          </HStack>
          <HStack p={8} HAlign="[">
            {QUICKUI.TextPreview(
              {EN: "Domestic Helper's name", TC: "家務助理姓名"},
              m_fullName ?? "NULL")}
          </HStack>
          {QUICKUI.TextPreview(
            {
              EN: "Date of birth",
              TC: "出生日期"
            },
            m_dateOfBirth ? ZTime.Moment(m_dateOfBirth).format("DD/MM/YYYY") 
              : "NULL")}
          {QUICKUI.TextPreview(
            {
              EN: "Gender",
              TC: "性別"
            },
            LocaleX.Parse(_gender?.cap ?? "NULL"))}
          {QUICKUI.TextPreview(
            {
              EN: "HKID/Passport", 
              TC: "香港身份證/護照"
            },
            m_passport ?? "NULL")}
          {QUICKUI.TextPreview(
            {
              EN: "Nationality",
                  TC: "國籍"
            },
            LocaleX.Parse(_nationality?.name ?? "NULL"))}
        </VStack>
      </VStack>
    );
  }

  renderConfirmation(){
    let {insured, loading} = this.state;
    return (
      <VStack fullWidth spacing={10}>
        <HStack flexShrink={0}>
          <XText color={ColorX.CSS("Leaf")} bold fontSize={22}>
            {LocaleX.Parse({
              EN: "Confirm Your Information",
              TC: "確認您的訊息"
            })}
          </XText>
        </HStack>
        <XScroll fullWidth>
          <HStack pH={20}flexShrink={0}>
            <XText fontSize={14}>
              {LocaleX.Parse({
                EN: "Please ensure that all details are accurate before signing, as any discrepancies may cause processing delays. Your signature authorizes our underwriting procedures. Misrepresentation of information could lead to denial or cancellation of coverage. Please be informed that your application is currently under evaluation, and coverage is pending.",
                TC: "請在簽名前確保所有詳細資訊準確無誤，因為任何差異都可能導致處理延遲。 您的簽名授權我們的核保程序。 虛假陳述資訊可能會導致承保被拒絕或取消。 請注意，您的申請目前正在評估中，承保範圍正在等待中。"
              })}
            </XText>
          </HStack>
          {this.renderPreviewCI()}
          <VStack fullWidth>
            {_.map(insured, (o, i) => {
              return this.renderPreviewInsured(o, i);
            })}
          </VStack>
          {this.renderPreviewInurance()}
          {this.renderPreviewRec()}
        </XScroll>
        {QUICKUI.PopupFooterButton(this._toSign, this._onSubmit, 
          {
            backCap: {
              EN: "Back",
              TC: "返回"
            }, 
            nextCap: {
              EN: "Submit",
              TC: "提交"
            }
          }, loading)}
      </VStack>
    );
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth fitHeightToContent maxHeight={window.innerHeight * 0.8} spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Order Placed Successfully",
                TC: "訂單下單成功"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtn} width={200} onPress={this._createNewPolicy}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Create new policy",
                    TC: "新增保單"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderSuppDoc(readOnly = false){
    let {recFormValue, insured, CIFormValue} = this.state;
    return (
      <QForm fullWidth onChange={this._onRecChange} readOnly={readOnly}
        value={recFormValue}>
        <XScroll height={readOnly ? "auto" : 600} pH={16} pV={16} overflow={readOnly ? "visible" : "auto"}>
          <VStack spacing={16} fullWidth bgColor={ColorX.CSS("pureWhite")} p={10} mV={10}>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Insured Person",
                  TC: "受保人"
                })}
              </XText>
            </HStack>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")}>
                {_.map(insured, o => o.m_fullName).join(", ")}
              </XText>
            </HStack>
          </VStack>
          <VStack spacing={16} fullWidth bgColor={ColorX.CSS("pureWhite")} p={10} mV={10}>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Certificate Holder",
                  TC: "證書持有者"
                })}
              </XText>
            </HStack>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")}>
                {LocaleX.Parse(CIFormValue?.meta?.fullName)}
              </XText>
            </HStack>
          </VStack>
          <VStack fullWidth>
            <Markdown textAlign="[">
              {LocaleX.Parse({
                EN: agreementEN?.({date: ZTime.Moment().format("DD/MM/YYYY"), signDate: ZTime.Now().format("DD/MM/YYYY")}),
                TC: agreementTC?.({date: ZTime.Moment().format("DD/MM/YYYY"), signDate: ZTime.Now().format("DD/MM/YYYY")})
              })}
            </Markdown>
          </VStack>
          <HStack spacing={5} HAlign="[" pV={20}>
            <QFCheckBox name="agreement"
              bColor={ColorX.CSS("pureWhite")}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Renewed")} fontSize={14}>
              {LocaleX.Parse({
                EN: "I have read and agree to make a signature.",
                TC: "我已閱讀並同意簽名。"
              })}
            </XText>
          </HStack>
          <VStack fullWidth>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Upload documents",
                  TC: "上傳文件"
                })}
              </XText>
            </HStack>
            <QFDropUpload 
              fileSizeLimit={10}
              name="documents" 
              accept=".jpg,.png,.pdf,.jpeg"
              uploadZoneProps={{
                bgColor: ColorX.CSS("pureWhite"),
                fullWidth: true 
              }} 
              uploadZoneInnerProps={{
                fullWidth: true
              }}
              btnBgColor={ColorX.CSS("Axit")}
              color={ColorX.CSS("Stone")}
              previewColor={ColorX.CSS("Leaf")}
              previewZoneProps={{
                fullWidth: true,
                pB: 30
              }}
              instantUpload
              multiple
              fullWidth/>
          </VStack>
          <VStack fullWidth mB={20}>
            <Markdown textAlign="[" pV={10}>
              {LocaleX.Parse({EN: paymentinstEN, TC: paymentinstTC})}
            </Markdown>
            <XDiv mV={10}>
              <XText bold fontSize={13}>
                {LocaleX.Parse({
                  EN: "FPS Payment QR Code",
                  TC: "FPS 轉數快收款 二維碼"
                })}
              </XText>
              <FPSQR/>
            </XDiv>
          </VStack>
          <VStack fullWidth>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Upload receipts",
                  TC: "上傳收據"
                })}
              </XText>
            </HStack>
            <QFDropUpload 
              fileSizeLimit={10}
              name="receipts" 
              accept=".jpg,.png,.pdf,.jpeg"
              uploadZoneProps={{
                bgColor: ColorX.CSS("pureWhite"),
                fullWidth: true 
              }} 
              uploadZoneInnerProps={{
                fullWidth: true
              }}
              btnBgColor={ColorX.CSS("Axit")}
              color={ColorX.CSS("Stone")}
              previewColor={ColorX.CSS("Leaf")}
              previewZoneProps={{
                fullWidth: true,
                pB: 30
              }}
              instantUpload
              multiple
              fullWidth/>
          </VStack>
        </XScroll>
        {!readOnly && QUICKUI.PopupFooterButton(this._toInsurance, this._toConfirmation, 
          {
            backCap: {
              EN: "Back",
              TC: "返回"
            }, 
            nextCap: {
              EN: "Next",
              TC: "下一步"
            },
            validateNext: this._validateReceipt
          })}
      </QForm>
    );
  }

  renderYesNoQuestions(question, name){
    return (
      <HStack pV={10} spacing={10} HAlign="[">
        <HStack width={300} pH={10} HAlign="[">
          <XText fontSize={14}
            color={ColorX.CSS("Stone")} 
            textAlign="[">
            {LocaleX.Parse(question)}
          </XText>
        </HStack>
        <HStack width={170} spacing={5} HAlign="[">
          <QFRadio name={name} refValue={true}/>
          <XText color={ColorX.CSS("Leaf")}>
            {LocaleX.Parse({
              EN: "Yes",
              TC: "是"
            })}
          </XText>
        </HStack>
        <HStack width={170} spacing={5} HAlign="[">
          <QFRadio name={name} refValue={false} 
            bColor={ColorX.CSS("Blood")}/>
          <XText color={ColorX.CSS("Blood")}>
            {LocaleX.Parse({
              EN: "No",
              TC: "否"
            })}
          </XText>
        </HStack>
      </HStack>
    );
  }

  renderPackage(pack, idx){
    let {_id, name, duration} = pack;
    let y1 = _.find(duration, o => o.year === 1);
    let y2 = _.find(duration, o => o.year === 2);
    return (
      <HStack pV={10} key={idx}>
        <HStack width={224} pH={10}>
          <XText fontSize={14}
            color={ColorX.CSS("Stone")} 
            textAlign="[">
            {LocaleX.Parse(name)}
          </XText>
        </HStack>
        <HStack width={224} spacing={5} HAlign="[">
          <QFRadio name="_package" refValue={`${_id}_1`}/>
          <XText color={ColorX.CSS("Leaf")}>
            {"HK$" + ZMath.NumberWithCommas(y1?.price)}
          </XText>
        </HStack>
        <HStack width={224} spacing={5} HAlign="[">
          <QFRadio name="_package" refValue={`${_id}_2`}/>
          <XText color={ColorX.CSS("Leaf")}>
            {"HK$" + ZMath.NumberWithCommas(y2.price)}
          </XText>
        </HStack>
      </HStack>
    );
  }

  renderEffectiveDateList(){
    let {insured} = this.state;
    return _.map(insured, (o, i) => {
      return (
        <VStack fullWidth key={i}>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Effective date",
                  TC: "生效日期"
                })}
              </XText>
              <XText fontSize={12} color={ColorX.CSS("Blood")}>{"*"}</XText>
            </HStack>
            <QFDate name={`proposeStartAt.${i}`} 
              placeholder={LocaleX.Parse({
                EN: "Choose policy effective date",
                TC: "選擇保單生效日期"
              })} 
              minDate={ZTime.StartOfDay().toISOString()}
              p={12}
              bW={1}
              height={44}
              isError={({field}) => !ZValidate.Check(field, ["required"])}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}/>
          </VStack>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Expired date",
                  TC: "有效期限"
                })}
              </XText>
              <XText fontSize={12} color={ColorX.CSS("Blood")}>{"*"}</XText>
            </HStack>
            <QFDate name={`proposeEndAt.${i}`} 
              readOnly
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}/>
          </VStack>
        </VStack>
      );
    });
  }

  renderPackageSection(){
    let {insuranceFormValue, totalAmount, minTotalAmount, packagesAvailable, insured} = this.state;
    let receiptPrice = Accessor.Get(insuranceFormValue, "receiptPrice");
    let containsMale = !_.every(insured, o => o.m_gender === "F");
    let isOverMin = false;
    if(receiptPrice){
      isOverMin = receiptPrice < minTotalAmount;
    }

    if(containsMale){
      return (
        <VStack fullWidth p={20}>
          <XText color={ColorX.CSS("Blood")}>
            {LocaleX.Parse({
              EN: "Policy for male domestic helpers will be further considered internally.",
              TC: "男性家務助理保單將在內部進一步考慮。"
            })}
          </XText>
          <HStack HAlign="[" pV={20}>
            <XText width={300} textAlign="[">
              {LocaleX.Parse({
                EN: "Policy Duration",
                TC: "保單年期"
              })}
            </XText>
            <HStack width={224} spacing={5} HAlign="[">
              <QFRadio name="_maleDuration" refValue={1}/>
              <XText color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "1 year",
                  TC: "1 年"
                })}
              </XText>
            </HStack>
            <HStack width={224} spacing={5} HAlign="[">
              <QFRadio name="_maleDuration" refValue={2}/>
              <XText color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "2 years",
                  TC: "2 年"
                })}
              </XText>
            </HStack>
          </HStack>
        </VStack>
      );
    }

    return (
      <VStack fullWidth>
        <HStack HAlign="[">
          <XText bold color={ColorX.CSS("Stone")}>
            {LocaleX.Parse({
              EN: "Package",
              TC: "套餐"
            })}
          </XText>
        </HStack>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack bgColor={ColorX.CSS("ActiveBg")} p={10}>
            <XText bold fontSize={14}
              color={ColorX.CSS("Active")} 
              textAlign="[" width={224}>
              {LocaleX.Parse({
                EN: "Insurance Coverage/Period",
                TC: "保險範圍/期限"
              })}
            </XText>
            <XText textAlign="[" width={224} bold fontSize={14}
              color={ColorX.CSS("Active")}>
              {LocaleX.Parse({
                EN: "1 year",
                TC: "1年"
              })}
            </XText>
            <XText textAlign="[" width={224} bold fontSize={14}
              color={ColorX.CSS("Active")}>
              {LocaleX.Parse({
                EN: "2 years",
                TC: "2年"
              })}
            </XText>
          </HStack>
          {_.map(packagesAvailable, (o, i) => {
            return this.renderPackage(o, i);
          })}
        </VStack>
        <VStack fullWidth>
          <HStack pV={10}>
            <XText>
              {LocaleX.Parse({
                EN: "Total",
                TC: "總額"
              })}
            </XText>
            <Spacer/>
            <XText>
              {"HK$" + ZMath.NumberWithCommas(totalAmount)}
            </XText>
          </HStack>
          <HStack pV={10}>
            <XText>
              {LocaleX.Parse({
                EN: "Receipt price (HK$)",
                TC: "收據價格 (HK$)"
              })}
            </XText>
            <Spacer/>
            <QFText
              name="receiptPrice"
              type="number"
              placeholder={LocaleX.Parse({
                EN: "Enter amount",
                TC: "輸入金額"
              })}
              width={157}
              p={12}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              />
          </HStack>
          {isOverMin &&
          <HStack>
            <XText color={ColorX.CSS("Blood")} fullWidth textAlign="]">
              {LocaleX.Parse({
                EN: `*This price reaches the limit, please enter the higher price. (HKD$ ${minTotalAmount})`,
                TC: `*此價格已達到上限，請輸入更高的價格。(HKD$ ${minTotalAmount})`
                })}
            </XText>
          </HStack>}
        </VStack>
      </VStack>
    );
  }

  renderInsurance(readOnly = false){
    let {insuranceFormValue} = this.state;
    return (
      <QForm fullWidth value={insuranceFormValue} readOnly={readOnly}
        onChange={this._onInsuranceChange}>
        <XScroll height={readOnly ? "auto" : 600} pH={16} overflow={readOnly ? "visible" : "auto"}>
          {this.renderPackageSection()}
          {this.renderEffectiveDateList()}
          <VStack fullWidth pV={10}>
            <HStack HAlign="[">
              <XText bold color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Responsible agent",
                  TC: "負責代理"
                })}
              </XText>
            </HStack>
            {QUICKUI.WebTextField("responsibleAgentEmail", {
              EN: "Email address",
              TC: "電郵"
            }, {width: "100%", starred: false, errorMessage:
              ZValidate.GetErrorMsg(Accessor.Get(insuranceFormValue, "responsibleAgentEmail"),
                ["email"])})}
            </VStack>
          <VStack pV={16}>
            <HStack HAlign="[">
              <XText bold color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Others",
                  TC: "其他"
                })}
              </XText>
            </HStack>
            <HStack>
              <XText color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Included the Government Levy, Government Terrorism Facility Charge and Employees' Compensation Insurer Insolvency Bureau Contribution",
                  TC: "包括政府徵費、政府恐怖主義融資費用和員工賠償保險公司破產局繳款"
                })}
              </XText>
            </HStack>
          </VStack>
          <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
            <HStack bgColor={ColorX.CSS("ActiveBg")} p={10} HAlign="[">
              <XText bold fontSize={14}
                color={ColorX.CSS("Active")} 
                textAlign="[" width={224}>
                {LocaleX.Parse({
                  EN: "Questionnaires",
                  TC: "問卷調查"
                })}
              </XText>
            </HStack>
            <HStack p={10}>
              <XText fontSize={14}
                color={ColorX.CSS("Stone")} 
                textAlign="[">
                {LocaleX.Parse({
                  EN: "Helper's Monthly Salary:",
                  TC: "助理月薪"
                })}
              </XText>
              <Spacer/>
              <QFText
                name="questions.salary"
                type="number"
                placeholder={LocaleX.Parse({
                  EN: "Enter amount",
                  TC: "輸入金額"
                })}
                width={157}
                p={12}
                min={0}
                focus_bColor={ColorX.CSS("Axit")}
                bColor={ColorX.CSS("Gray5")}
              />
            </HStack>
            {this.renderYesNoQuestions({
              EN: "Is your domestic helper receiving or contemplating any medical attention or surgical treatment or taking any medicine?",
              TC: "您的家庭傭工是否正在接受或考慮接受任何醫療護理或手術治療或服用任何藥物？"
            }, "questions.medical")}
            <HStack HAlign="[" p={10}>
              {QUICKUI.WebTextField("questions.medicalinfo", 
                {
                  EN: "If any of the above answer is \"Yes\", please provide full details",
                  TC: "如果以上任何一個答案為\"是\"，請提供完整的詳細資訊"
                }, {width: "100%", multilines: true, height: 100, isError:
                  ({field}) => insuranceFormValue?.questions?.medical && !field
                })}
            </HStack>
            <HStack HAlign="[" p={10}>
              {this.renderYesNoQuestions({
                  EN: "Have you ever been refused for application or renewal of, or requested for cancellation of domestic helper insurance by any insurance company or subject to special terms and conditions?",
                  TC: "您是否曾被任何保險公司拒絕申請、續保、或要求取消家庭傭工保險，或受特別條款及細則約束？"
                }, "questions.reject")}
            </HStack>
            <HStack HAlign="[" p={10}>
              {QUICKUI.WebTextField("questions.history", 
                {
                  EN: "If any of the above answer is \"Yes\", please provide full details",
                  TC: "如果以上任何一個答案為\"是\"，請提供完整的詳細資訊"
                }, {width: "100%", multilines: true, height: 100, isError:
                  ({field}) => insuranceFormValue?.questions?.reject && !field})}
            </HStack>
          </VStack>
        </XScroll>
        {!readOnly && QUICKUI.PopupFooterButton(this._toInsured, this._toSign, 
          {
            backCap: {
              EN: "Back",
              TC: "返回"
            },
            validateNext: this._validateInsurance
          })}
      </QForm>
    );
  }

  renderInsuredBox(o, i){
    let {oldMaids, nationalities} = this.state;
    let {_newMaid = false} = o;

    let dateError = _newMaid && 
      ZValidate.GetErrorMsg(Accessor.Get(o, "m_dateOfBirth"),
      ["required"]);
    return (
      <QForm fullWidth pH={16} mB={16} key={i} value={o}
        onChange={(formValue, name, value) => this._onInsuredChange(i, formValue, name, value)}>
        <VStack bW={2} bColor={ColorX.CSS("Leaf")} fullWidth pB={4}>
          <HStack bgColor={ColorX.CSS("Leaf")} HAlign="[" pH={16} pV={8}>
            <XText color={ColorX.CSS("pureWhite")} bold>
              {LocaleX.Parse({
                EN: `Domestic Helper #${i + 1}`,
                TC: `家務助理 #${i + 1}`,
              })}
            </XText>  
            <Spacer/>
          </HStack>
          <VStack fullWidth pH={8}>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "Please note that the price and regulations for male domestic helpers will be different.",
                  TC: "請注意，男家務助理的價格和規定會有所不同。"
                })}
              </XText> 
            </HStack>
            <HStack HAlign="[" pH={10} height={50}>
              <HStack spacing={10} width={145} HAlign="[">
                <QFRadio name="_newMaid" refValue={true} 
                  bColor={ColorX.CSS("Axit")}/>
                  <XText color={ColorX.CSS("Stone")}>
                    {LocaleX.Parse({
                      EN: "New helper",
                      TC: "新助理"
                    })}
                  </XText>
              </HStack>
              <HStack spacing={10} width={150} HAlign="[">
                <QFRadio name="_newMaid" refValue={false} 
                  bColor={ColorX.CSS("Axit")}/>
                <XText color={ColorX.CSS("Stone")}>
                  {LocaleX.Parse({
                    EN: "Existing helper",
                    TC: "現有助理"
                  })}
                </XText>
              </HStack>
            </HStack>
            {!_newMaid &&
              <QFDropdown name={"existingMaid"}
                allowSearch
                options={oldMaids}
                capAccessor="fullName"
                valAccessor="_id"
                placeholder={LocaleX.Parse({
                  EN: "Select Existing helper",
                  TC: "選擇現有助理"
                })}
                p={12}
                bW={1}
                height={44}
                focus_bColor={ColorX.CSS("Axit")}
                bColor={ColorX.CSS("Gray5")}
                onSelectChange={(_id) => this._selectOldMaid(i, _id)}
                />
              }
            <HStack>
              {QUICKUI.WebTextField("m_fullName",
                {EN: "Helper's name", TC: "助理姓名"},
                {readOnly: !_newMaid, width: "100%", 
                  errorMessage: 
                  _newMaid &&
                  ZValidate.GetErrorMsg(Accessor.Get(o, "m_fullName"), 
                  ["required"])
                })}
            </HStack>
            {QUICKUI.WebDateField("m_dateOfBirth",
              {EN: "Date of birth", TC: "出生日期"},
              {readOnly: !_newMaid, width: "100%", 
                errorMessage: dateError,
                minDate: ZTime.Now().add(-60, "years").toISOString(),
                maxDate: ZTime.Now().add(-18, "years").toISOString(),
                defaultDisYear: ZTime.Now().add(-25, "years").year(),
                isError: ({field}) => _newMaid && !ZValidate.Check(field, ["required"])
              })}
            {QUICKUI.WebDropdown("m_gender", {
              EN: "Gender",
              TC: "性別"
            }, Options.GetOptionList("Gender"),
            {readOnly: !_newMaid, width: "100%", starred: true,
              placeholder: {
                EN: "Gender",
                TC: "性別"
              },
              errorMessage: 
              _newMaid &&
              ZValidate.GetErrorMsg(Accessor.Get(o, "m_gender"), 
              ["required"])})}
            {QUICKUI.WebTextField("m_passport",
              {EN: "Passport number / HKID", TC: "護照 / 香港身份證號碼"},
              {readOnly: !_newMaid, noSpecialCharacter: true, 
                errorMessage: 
                _newMaid &&
                ZValidate.GetErrorMsg(Accessor.Get(o, "m_passport"), 
                ["required"]),
                width: "100%"
              })}
            {QUICKUI.WebDropdown("m_nationality", {
              EN: "Nationality",
              TC: "國籍"
            }, nationalities, {
              readOnly: !_newMaid, starred: true,
              valAccessor: "_id",
              capAccessor: "name",
              placeholder: {
                EN: "Nationality",
                TC: "國籍"
              },
              errorMessage:
              _newMaid &&
              ZValidate.GetErrorMsg(Accessor.Get(o, "m_nationality"), 
              ["required"])
            })}
          </VStack>
        </VStack>
      </QForm>
    );
  }

  renderInsuredInfo(){
    let {insured} = this.state;
    return (
      <VStack fullWidth>
        <XScroll fullWidth height={600}>
          {_.map(insured, (o, i) => {
            return this.renderInsuredBox(o, i);
          })}
          <HStack HAlign="[" p={16}>
            <XText color={ColorX.CSS("Blood")} textAlign="[">
              {LocaleX.Parse({
                EN: "Remark: \n1) Please make sure all the helpers are applying the same application form and type.\n2) The domestic helper insured shall be between the age of 18 and 60.\n3) If the domestic helper is male, please contact Mutual for further proceed.",
                TC: "備註：\n1) 請確保所有工人都申請相同的申請表和類型。\n2) 受保家庭傭工的年齡須介乎18歲至60歲。\n3) 若家庭傭工為男性，請聯絡 Mutual 進一步處理。"
              })}
            </XText>
          </HStack>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._backCI, this._toInsurance,
          {
            backCap: { 
              EN: "Back", 
              TC: "返回" 
            },
            validateNext: this._validateInsured
          })}
      </VStack>
    );
  }

  renderCustomerInfo(){
    let {CIFormValue, oldClients} = this.state;
    let {_newClient = false, meta = {}, _sameWorkingAddress = true} = CIFormValue ?? {};
    let {additionalAddress} = meta ?? {};
    let employmentAddressOptions = _.compact(_.map(additionalAddress, (addr, i) => {
      if(!addr?.EN && !addr?.TC){
        return null;
      }
      return {
        cap: {
          EN: addr.EN || addr.TC || `Additional address #${i + 1}`,
          TC: addr.TC || addr.EN || `附加地址 #${i + 1}`
        },
        val: String(i)
      };
    }));
    return (
      <VStack fullWidth>
        <XScroll fullWidth pH={16}>
          <QForm onChange={this._onCIChange} p={8} spacing={10}
            fullWidth value={CIFormValue}>
            <HStack spacing={20} HAlign="[" height={50}>
              <HStack spacing={10} width={145} HAlign="[">
                <QFRadio name="_newClient" refValue={true} 
                  bColor={ColorX.CSS("Axit")}/>
                  <XText color={ColorX.CSS("Stone")}>
                    {LocaleX.Parse({
                      EN: "New client",
                      TC: "新客戶"
                    })}
                  </XText>
              </HStack>
              <HStack spacing={10} width={150} HAlign="[">
                <QFRadio name="_newClient" refValue={false} 
                  bColor={ColorX.CSS("Axit")}/>
                <XText color={ColorX.CSS("Stone")}>
                  {LocaleX.Parse({
                    EN: "Existing client",
                    TC: "現有客戶"
                  })}
                </XText>
              </HStack>
            </HStack>
            {!_newClient &&
              <QFDropdown name={"existingClient"}
                allowSearch
                capAccessor="meta.fullName"
                valAccessor="_id"
                options={oldClients}
                placeholder={LocaleX.Parse({
                  EN: "Select Existing Client",
                  TC: "選擇現有客戶"
                })}
                p={12}
                bW={1}
                height={44}
                width={320}
                focus_bColor={ColorX.CSS("Axit")}
                bColor={ColorX.CSS("Gray5")}
                onSelectChange={this._selectOldClient}
                isError={({field}) => !_newClient && !field}
                />
              }
            {QUICKUI.WebTextField("meta.fullName.EN",
              {EN: "Full name", TC: "姓名"},
              {readOnly: !_newClient, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "meta.fullName.EN"),
                  ["required"]
                )
              })}
            {QUICKUI.WebTextField("meta.fullName.TC",
              {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
              {starred: false, readOnly: !_newClient})}
            {QUICKUI.WebTextField("email",
              {EN: "Email", TC: "電郵"},
              {readOnly: !_newClient, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "email"),
                  ["required", "email"]
                )}
            )}
            {QUICKUI.WebDropdown("meta.gender", 
              { EN: "Gender", TC: "性別" },
              Options.GetOptionList("Gender"),
              {readOnly: !_newClient, width: "100%", placeholder:
                { EN: "Gender", TC: "性別" },
                disabled_bgColor: ColorX.CSS("transparent"),
                starred: false, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "meta.gender"),
                  ["required"]
                )
              }
            )}
            {QUICKUI.WebTextField("meta.HKID",
              {EN: "HKID number", TC: "香港身份證號碼"},
              {readOnly: !_newClient, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "meta.HKID"),
                  ["required", "isHKID"]
                )}
            )}
            {QUICKUI.WithZipCode("telNo", 
              { EN: "Mobile phone", TC: "手機號碼" },
              { 
                readOnly: !_newClient,
                placeholder: {
                  EN: "Enter your mobile phone no.",
                  TC: "輸入你的電話號碼"
                }, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "telNo"),
                  ["required"]
                )
              })}           
            {QUICKUI.WebTextField("meta.primaryAddress.EN",
              {EN: "Primary address (English)", TC: "主要地址 (英文)"},
              {width: "100%", readOnly: !_newClient, errorMessage:
                _newClient && 
                ZValidate.GetErrorMsg(
                  Accessor.Get(CIFormValue, "meta.primaryAddress.EN"),
                  ["required"]
                )},
            )}
            {QUICKUI.WebTextField("meta.primaryAddress.TC",
              {EN: "(Chinese)", TC: "(中文)"},
              {width: "100%", readOnly: !_newClient, starred: false},
            )}
              {QUICKUI.WebTextField("workingAddress.EN",
                {EN: "Place of Employment (English)", TC: "工作地址 (英文)"},
                {width: "100%", readOnly: _sameWorkingAddress, errorMessage:
                  _newClient && !_sameWorkingAddress &&
                  ZValidate.GetErrorMsg(
                    Accessor.Get(CIFormValue, "workingAddress.EN"),
                    ["required"]
                  )})}
              {QUICKUI.WebTextField("workingAddress.TC",
                {EN: "(Chinese)", TC: "(中文)"},
                {width: "100%", readOnly: _sameWorkingAddress, starred: false}, 
                <HStack spacing={10} HAlign="[" fitWidthToContent>
                  <QFCheckBox name="_sameWorkingAddress" defaultValue={true} 
                    bColor={ColorX.CSS("Axit")} size={14}/>
                    <XText color={ColorX.CSS("Stone")} fontSize={12}>
                      {LocaleX.Parse({
                        EN: "Same as address above",
                        TC: "工作地址與地址相同"
                      })}
                    </XText>
                </HStack>)}
            {!_sameWorkingAddress && employmentAddressOptions.length > 0 &&
            <HStack HAlign="[" fullWidth>
              {QUICKUI.WebDropdown("_employmentAddrPreset",
                {
                  EN: "Place of employment (from client additional addresses)",
                  TC: "工作地址（從客戶附加地址選擇）"
                },
                employmentAddressOptions,
                {
                  starred: false,
                  width: "100%",
                  placeholder: {
                    EN: "Select an address",
                    TC: "選擇地址"
                  },
                  onSelectChange: this._applyEmploymentAddressFromSaved
                }
              )}
            </HStack>}
            
            <VStack HAlign="[" fullWidth>
              {_.map(additionalAddress, (o, i) => {
                return (
                  <VStack fullWidth VAlign="_" key={i} HAlign="[" spacing={24}>
                    {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                      {
                        EN: `Additional Address #${i+1} (English)`,
                        TC: `附加地址 #${i+1} (英文)`
                      }, {width: "100%", starred: false, readOnly: !_newClient,
                        errorMessage:
                        _newClient && 
                        ZValidate.GetErrorMsg(
                          Accessor.Get(CIFormValue, `meta.additionalAddress.${i}.EN`),
                          ["required"]
                        )})}
                    <HStack>
                      {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                        {
                          EN: "(Chinese)",
                          TC: "(中文)"
                        }, {width: "100%", starred: false, readOnly: !_newClient})}
                      <XButton color={ColorX.CSS("Blood")} disabled={!_newClient} 
                        onPress={() => this._removeRow("meta.additionalAddress", i)}>
                        <MdClose/>
                      </XButton>
                    </HStack>
                  </VStack>
                );
              })}
            </VStack>
            <HStack HAlign="[">
              <XButton color={ColorX.CSS("Axit")} disabled={!_newClient}
                onPress={() => this._addRow("meta.additionalAddress")}>
                <HStack>
                  <XText bold>
                    {LocaleX.Parse({
                      EN: "+ Add more address",
                      TC: "+ 增加更多地址"
                    })}
                  </XText>
                </HStack>
              </XButton>
            </HStack>
          </QForm>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._close, this._toInsured, 
          {
            validateNext: this._validateCI
          })}
      </VStack>
    );
  }

  renderMain(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderCustomerInfo();
      case 1: return this.renderInsuredInfo();
      case 2: return this.renderInsurance();
      case 3: return this.renderSuppDoc();
      case 4: return this.renderConfirmation();
      case 5: return this.renderSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        fullWidth maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        <XScroll fullWidth>
          {this.renderStepper()}
          {this.renderMain()}
        </XScroll>
      </VStack>
    );
  }

}

export default observer(NewPolicyM);
